import React, { useEffect, useState } from 'react';
import { IconButton, Box, Grid, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { ReactComponent as DeleteIcon } from '../assets/images/deleteRedIcon.svg';
import { success } from '../utils/message-box';
import {
    CustomerBorderedInput,
    CustomerBorderedSelect,
    CustomerFieldLabel,
} from '../utils/customerFormUi.js';

const DynamicForm = (props) => {
    const [rows, setRows] = useState([
        { id: Date.now(), size: '', product_type: '', quantity: '' },
    ]);

    useEffect(() => {
        if (props?.sizeDetails?.length) {
            setRows(props?.sizeDetails);
        }
    }, [props?.sizeDetails]);

    useEffect(() => {
        if (props?.clearForm) {
            setRows([
                ...[1].map(() => ({
                    id: Date.now(),
                    size: '',
                    product_type: '',
                    quantity: '',
                })),
            ]);
            props?.setClearForm(false);
        }
    }, [props?.clearForm]);

    const productTypeOptions = [
        { name: 'B', label: 'Long Length(B)' },
        { name: 'SB', label: 'Short Length(SB)' },
        { name: 'FG', label: 'Fishing Shoes Soft(FG)' },
        { name: '2FG', label: 'Fishing Shoes Strong(2FG)' },
        { name: 'OR', label: 'Orange Shoe(OR)' },
        { name: 'WF', label: 'Waders(WF)' },
        { name: 'PR', label: 'Poorner(PR)' },
        { name: 'SPS', label: 'Safty Protection Suit(SPS)' },
    ];

    const productSizes = [
        { value: 36, size: '3/36' },
        { value: 37, size: '4/37' },
        { value: 38, size: '5/38' },
        { value: 39, size: '6/39' },
        { value: 40, size: '7/40' },
        { value: 41, size: '8/41' },
        { value: 42, size: '9/42' },
        { value: 43, size: '10/43' },
        { value: 44, size: '11/44' },
        { value: 45, size: '12/45' },
        { value: 46, size: '13/46' },
        { value: 0, size: 'free' },
    ];

    const FishingSizes = [
        { value: 36, size: '2/36' },
        { value: 37, size: '3/37' },
        { value: 38, size: '4/38' },
        { value: 39, size: '5/39' },
        { value: 40, size: '6/40' },
        { value: 41, size: '7/41' },
        { value: 42, size: '8/42' },
        { value: 43, size: '9/43' },
        { value: 44, size: '10/44' },
        { value: 45, size: '11/45' },
        { value: 46, size: '12/46' },
    ];

    const productORSizes = [
        { value: 1, size: '5/1' },
        { value: 2, size: '6/2' },
        { value: 3, size: '7/3' },
        { value: 4, size: '8/4' },
        { value: 5, size: '9/5' },
        { value: 6, size: '10/6' },
        { value: 7, size: '11/7' },
    ];

    function calculateWeight(product_type, quantity) {
        let weight = 0;

        if (product_type === 'SB' || product_type === 'B') {
            weight = Number(quantity) === 1 ? 1350 : 1150 * Number(quantity);
        } else if (product_type === 'OR') {
            weight = Number(quantity) === 1 ? 750 : 700 * Number(quantity);
        } else if (product_type === 'FG') {
            weight = Number(quantity) === 1 ? 1600 : 1450 * Number(quantity);
        } else if (product_type === '2FG') {
            weight = Number(quantity) === 1 ? 1900 : 1600 * Number(quantity);
        } else if (product_type === 'SPS') {
            weight = Number(quantity) === 1 ? 650 : 650 * Number(quantity);
        }

        return weight;
    }

    const handleAddRow = () => {
        const newRow = { id: Date.now(), size: '', product_type: '', quantity: '' };
        const updatedRows = [...rows, newRow];
        setRows(updatedRows);
        props?.setSizeDetails(updatedRows);
    };

    const handleDeleteRow = (id) => {
        if (rows.length > 1) {
            const updatedRows = rows.filter((row) => row.id !== id);
            setRows(updatedRows);
            props?.setSizeDetails(updatedRows);
            success('Size details deleted successfully.');
        }
    };

    const handleChange = (id, field, value) => {
        const updatedRows = rows.map((row) =>
            row.id === id ? { ...row, [field]: value === 'free' ? 0 : value } : row
        );
        setRows(updatedRows);
        props?.setSizeDetails(updatedRows);
    };

    useEffect(() => {
        const total = rows.reduce((acc, row) => acc + calculateWeight(row.product_type, row.quantity), 0);
        props?.setWeight(total);
    }, [rows]);

    const getSizeOptions = (productType) => {
        if (productType === 'OR') return productORSizes;
        if (productType === 'FG' || productType === '2FG' || productType === 'WF') return FishingSizes;
        return productSizes;
    };

    return (
        <Box>
            {rows.map((row) => (
                <Grid
                    container
                    spacing={{ xs: 1, md: 1.5 }}
                    alignItems="flex-end"
                    key={row.id}
                    className="customer-form-size-row"
                >
                    <Grid item xs={12} sm={6} md={3}>
                        <CustomerFieldLabel label="Type" required />
                        <CustomerBorderedSelect
                            value={row.product_type || 'default'}
                            onChange={(e) => handleChange(row.id, 'product_type', e.target.value)}
                        >
                            <MenuItem key="default" value="default" disabled>
                                --Select--
                            </MenuItem>
                            {productTypeOptions.map((oppor) => (
                                <MenuItem key={oppor.name} value={oppor.name}>
                                    {oppor.label}
                                </MenuItem>
                            ))}
                        </CustomerBorderedSelect>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <CustomerFieldLabel label="Size" required />
                        <CustomerBorderedSelect
                            value={row.size !== undefined && row.size !== null && row.size !== '' ? row.size : 'default'}
                            onChange={(e) => handleChange(row.id, 'size', e.target.value)}
                        >
                            <MenuItem key="default" value="default" disabled>
                                --Select--
                            </MenuItem>
                            {getSizeOptions(row.product_type)?.map((size) => (
                                <MenuItem key={size.value} value={size.value}>
                                    {size.size}
                                </MenuItem>
                            ))}
                        </CustomerBorderedSelect>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <CustomerFieldLabel label="Quantity" required />
                        <CustomerBorderedInput
                            placeholder="Enter quantity"
                            value={row.quantity}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (value >= 0) {
                                    handleChange(row.id, 'quantity', value);
                                }
                            }}
                            inputProps={{ autoComplete: 'off', inputMode: 'numeric' }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <Box className="customer-form-size-actions">
                            <IconButton
                                onClick={handleAddRow}
                                aria-label="Add size row"
                                className="customer-form-action-icon customer-form-action-icon--add"
                            >
                                <AddIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                                onClick={() => handleDeleteRow(row.id)}
                                aria-label="Delete size row"
                                disabled={rows.length <= 1}
                                className="customer-form-action-icon customer-form-action-icon--delete"
                            >
                                <DeleteIcon />
                            </IconButton>
                        </Box>
                    </Grid>
                </Grid>
            ))}
        </Box>
    );
};

export default DynamicForm;
